import type { GradeEffect, ModeConfig, SessionMode } from "./types";

export const MODE_CONFIG: Record<SessionMode, ModeConfig> = {
  confidence: {
    targetAccuracy: 0.88,
    minPCorrect: 0.55,
    maxHardFraction: 0.1,
    newFraction: 0.15,
  },
  standard: {
    targetAccuracy: 0.78,
    minPCorrect: 0.4,
    maxHardFraction: 0.2,
    newFraction: 0.2,
  },
  cram: {
    targetAccuracy: 0.68,
    minPCorrect: 0.3,
    maxHardFraction: 0.3,
    newFraction: 0.25,
  },
};

export const GRADE_EFFECT: Record<string, GradeEffect> = {
  again: { deltaMemory: -0.18, deltaDifficulty: 0.1, nextMinutes: 10 },
  hard: { deltaMemory: 0.05, deltaDifficulty: 0.03, nextHours: 12 },
  good: { deltaMemory: 0.12, deltaDifficulty: -0.02, nextDaysFactor: 1.8 },
  easy: { deltaMemory: 0.18, deltaDifficulty: -0.05, nextDaysFactor: 2.5 },
};

export const DEFAULTS = {
  sessionSize: 20,
  targetBandHalfwidth: 0.05,
  retryDelayMinutes: 5,
  boosterFraction: 0.05,
  retryFraction: 0.15,
  groupUnlockMastery: 0.78,
  groupUnlockStableFraction: 0.8,
  stableMemoryStrength: 0.6,
  stablePCorrect: 0.8,
  hardResponseMs: 5000,
  easyResponseMs: 2500,
};

// Scoring weights
export const SCORING_WEIGHTS = {
  urgency: 0.3,
  learningGain: 0.3,
  moraleFit: 0.25,
  diversityBonus: 0.1,
  frustrationRisk: 0.25,
  targetPenalty: 0.35,
};

// Predictor coefficients
export const PREDICTOR_COEFFICIENTS = {
  memoryStrength: 2.2,
  difficulty: -1.4,
  timeFactor: -0.35,
  consecutiveCorrect: 0.22,
  recentFailure: -0.45,
  sameDayRepeat: -0.18,
  speedPenalty: -0.1,
};

// Learning gain bell curve parameters
export const LEARNING_GAIN_CENTER = 0.65;
export const LEARNING_GAIN_SIGMA = 0.18;

// Morale fit bell curve parameters
export const MORALE_FIT_SIGMA = 0.12;

// New item p_correct values
export const NEW_ITEM_P_CORRECT = 0.35;
export const LEARNING_FIRST_ATTEMPT_P_CORRECT = 0.45;

// Retry bonus threshold
export const RETRY_BONUS_VALUE = 0.18;
export const NOVELTY_BONUS_VALUE = 0.08;
export const DIVERSITY_BONUS_VALUE = 0.15;

// Explanation recovery bonus
export const EXPLANATION_RECOVERY_BONUS = 0.08;
